module.exports = __webpack_public_path__ + "static/media/estrella_off.0eee7d82.svg";